import queryString, {
  type ParseOptions,
  type StringifyOptions,
} from 'query-string'

export const parseQueryString = (query: string, options?: ParseOptions) => {
  return queryString.parse(query, {
    arrayFormat: 'bracket',
    ...options,
  })
}
export const stringifyQueryString = (
  data: Record<string, any>,
  options?: StringifyOptions,
) => {
  return queryString.stringify(data, {
    arrayFormat: 'bracket',
    skipNull: true,
    ...options,
  })
}
